import React from "react";
import { useApp } from "../context/AppContext";

const Marquee = () => {
  const { t } = useApp();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <div className="w-full bg-[#EFE2DA] border-y border-[#E4D0C4] overflow-hidden py-3.5">
      <div className="flex w-max animate-marquee">
        {items.map((item, i) => (
          <span
            key={i}
            className="flex items-center text-[11px] tracking-label uppercase text-[#8A6E5F] px-8 whitespace-nowrap"
          >
            {item}
            <span className="ml-8 h-1 w-1 rounded-full bg-[#C79A7E]" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
